import { WalkingNotice } from 'components/OnlineBooking/Walking/Address/WalkingNotice';
import classes from 'components/OnlineBooking/Walking/Address/WalkingNotice.module.scss';
import React from 'react';

interface OutOfAreaNoticeProps {
    onChangeAddress: () => void;
}

export const OutOfAreaNotice: React.FC<OutOfAreaNoticeProps> = ({ onChangeAddress }) => {
    return (
        <WalkingNotice>
            <p className={classes.text}>
                In-Home services aren&apos;t available at your address yet. At Facility services are
                still available.{' '}
                <button type="button" className={classes.link} onClick={onChangeAddress}>
                    Change Address
                </button>
            </p>
        </WalkingNotice>
    );
};
